import * as Yup from "yup";

export const LOGIN_SCHEMA = Yup.object().shape({
  email: Yup.string()
    .email("Please enter correct email")
    .required("Email is required"),
  password: Yup.string().required("Password is required"),
});
